import moment from 'moment';
export const sinceEpoch = (seconds) => {
    let date = new Date(0);
    date.setUTCSeconds(seconds);
    return date;
};
export const newCoEffectiveDate  =  "12/01/2023";
   